import { useState } from "react";
import { TextField } from "@mui/material";

const UserInfoEmergency = ({
  isEdit,
  userInfo,
  setUserInfo,
  validateStatus,
  setValidateStatus,
  setKeyboardOpen
}) => {
  const [isJpPhone, setIsJpPhone] = useState(
    userInfo.emergencyContact?.startsWith("+81") ?? false
  );

  const getPhoneWithoutCountryCode = (phone) =>
    phone?.replace(/^(\+81|\+63)/, "") ?? "";

  const emergencyContactHandler = (value) => {
    const raw = value.trim();
    const digitsOnly = raw.replace(/[^\d]/g, "");

    // 未入力時はバリデーションをクリア
    if (digitsOnly === "") {
      setValidateStatus((prev) => ({
        ...prev,
        emergencyContact: { valid: true, message: "" }
      }));
      setUserInfo((prev) => ({ ...prev, emergencyContact: "" }));
      return;
    }

    let val = { valid: true, message: "" };
    if (digitsOnly.length < 7 || digitsOnly.length > 10) {
      val.valid = false;
      val.message = "電話番号は7〜10文字で登録してください";
    }

    setValidateStatus((prev) => ({
      ...prev,
      emergencyContact: val
    }));

    setUserInfo((prev) => ({
      ...prev,
      emergencyContact: `${isJpPhone ? "+81" : "+63"}${digitsOnly}`
    }));
  };

  const handlePhoneTypeToggle = (checked) => {
    setIsJpPhone(checked);
    const digitsOnly = getPhoneWithoutCountryCode(userInfo.emergencyContact);
    if (digitsOnly) {
      setUserInfo((prev) => ({
        ...prev,
        emergencyContact: `${checked ? "+81" : "+63"}${digitsOnly}`
      }));
    }
  };

  const emergencyPersonHandler = (input) => {
    let val = { valid: true, message: "" };
    const allowedRegex =
      /^[\u3040-\u30FF\u4E00-\u9FFF\uFF10-\uFF19 0-9a-zA-Z\s()/／（）]+$/;

    if (input.length > 50) {
      val.valid = false;
      val.message = "50文字以内で入力してください";
    } else if (!allowedRegex.test(input) && input.length > 0) {
      val.valid = false;
      val.message = "日本語またはローマ字で入力してください";
    }

    setValidateStatus((prev) => ({
      ...prev,
      emergencyPerson: val
    }));
    setUserInfo((prev) => ({ ...prev, emergencyPerson: input }));
  };

  return (
    <dl className="dl" style={{ marginBottom: "42px" }}>
      <dt>電話番号{isEdit && <span>※</span>}</dt>
      <dd className="tell">
        {isEdit ? (
          <div>
            <div className="phoneForm">
              <label htmlFor="phone">
                <input
                  checked={isJpPhone}
                  type="checkbox"
                  onChange={(e) => handlePhoneTypeToggle(e.target.checked)}
                  id="phone"
                />
                {isJpPhone ? <span>🇯🇵+81</span> : <span>🇵🇭+63</span>}
              </label>
              <TextField
                value={getPhoneWithoutCountryCode(userInfo.emergencyContact)}
                onChange={(e) => emergencyContactHandler(e.target.value)}
                error={!validateStatus.emergencyContact?.valid}
                helperText={validateStatus.emergencyContact?.message}
                onFocus={() => setKeyboardOpen(true)}
                onBlur={() => setKeyboardOpen(false)}
                InputProps={{
                  sx: {
                    "& input": {
                      padding: "8px 16px"
                    }
                  }
                }}
                sx={{ width: "100%" }}
              />
            </div>
            <small>日本/フィリピンに切り替えられます</small>
          </div>
        ) : (
          <div className="col">{userInfo.emergencyContact}</div>
        )}
      </dd>

      <dt>氏名と続柄{isEdit && <span>※</span>}</dt>
      <dd>
        {isEdit ? (
          <div>
            <TextField
              value={userInfo.emergencyPerson}
              onChange={(e) => emergencyPersonHandler(e.target.value)}
              error={!validateStatus.emergencyPerson?.valid}
              helperText={validateStatus.emergencyPerson?.message}
              onFocus={() => setKeyboardOpen(true)}
              onBlur={() => setKeyboardOpen(false)}
              InputProps={{
                sx: {
                  "& input": {
                    padding: "8px 16px"
                  }
                }
              }}
              sx={{ width: "100%" }}
            />
          </div>
        ) : (
          <div>{userInfo.emergencyPerson}</div>
        )}
      </dd>
    </dl>
  );
};

export default UserInfoEmergency;
